export function openDonationCheckout(amount: number, type: 'one-time' | 'monthly'): void {
  const params = new URLSearchParams({
    amount: Math.round(amount * 100).toString(),
    currency: 'usd',
    type,
  });
  window.open(`https://donate.mamaobaby.com/checkout?${params.toString()}`, '_blank');
}
